<template lang="pug">
.date-picker
  .month {{mon}}
    span 月
  .slides
    .swiper-container(ref="swiper")
      .swiper-wrapper(ref="swiperWrapper")
        .swiper-slide(v-for="(day, idx) in calenders" :key="idx")
          .day-card(:class="selectedDate === idx? 'selected': ''" @click="onDayClick(idx)")
            .copy
              .week {{$t(`date.week[${day.date.getDay()}]`)}}
              .day  {{day.date.getDate()}}
  //flex(:height="50")
  .indicator
    .wrapper(ref="indicator")
      img.pin(ref="pin" src="~assets/indicator-pin.jpg")
  //flex(:height="25")
  .picker
    transition-group(name="fade")
      .time-picker(v-for="(s, i) in schedules0" :key="i" )
        time-picker-card(:schedule="s" :active="selectedTime === i" @clicked="onTimeClick(i, s)")

            
</template>
<script>
import Swiper from 'swiper'
import Raf from '@/helpers/Raf'
import Flex from '@/components/Flex'
import TimePickerCard from '@/components/res/TimePickerCard'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'DatePicker',
  components: { TimePickerCard, Flex },
  props: {},
  data() {
    return {
      curIdx: 0,
      //curMonth: 4,
      selectedDate: -1,
      selectedTime: -1,
      lineOffset: 0,
      lineOffsetTo: 0,
      pinOffset: 0,
      pinOffsetTo: 0,
      lineEl: null,
      swiperWrapperEl: null,
      pinEl: null,
      // eslint-disable-next-line vue/no-reserved-keys
      schedules0: [],
      schedulesAnimTimeout: [],
      curMonth: '',
    }
  },
  computed: {
    ...mapState('app', ['scheduleTable', 'calenders', 'schedules', 'user']),
    mon() {
      if (this.curMonth < 10) return '0' + this.curMonth
      else return this.curMonth
    },
    // curMonth() {
    //   if (this.calenders.length > 0)
    //     return this.calenders[this.curIdx].date.getMonth() + 1
    //   else return ''
    // },
  },
  watch: {
    calenders(val) {
      this.updateCalendar()
    },
    schedules(val) {
      console.log(99999, val)
      this.clearSchedules()
      val.map((s, i) => {
        let tl = setTimeout(() => {
          this.schedules0.push(s)
        }, 100 * (i + 1) + 200)
        this.schedulesAnimTimeout.push(tl)
      })
    },
  },
  methods: {
    ...mapActions('app', ['GetCalenders', 'GetSchedules']),
    onDayClick(idx) {
      this.selectedDate = idx
      this.selectedTime = -1
      this.$emit('reset')
      this.alignDayPin(idx)
      this.updateSchedules(idx)
      this.curMonth = this.calenders[idx].date.getMonth() + 1
    },
    updateSchedules(idx) {
      this.clearSchedules()
      this.GetSchedules({ date: this.calenders[idx].id, userId: this.user.id })
    },
    updateCalendar() {
      this.curMonth = this.calenders[0].date.getMonth() + 1
      this.swiper = new Swiper(this.$refs.swiper, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        freeMode: true,
        on: {
          slideChange: (swiper) => {
            this.curIdx = swiper.activeIndex
            //console.log(swiper.activeIndex)
            // this.curMonth =
            //   this.calenders[swiper.activeIndex].date.getMonth() + 1
          },
        },
      })
      Raf.add(this.syncIndicator)
      setTimeout(() => {
        this.onDayClick(0)
      }, 100)
    },
    clearSchedules() {
      while (this.schedules0.length > 0) this.schedules0.pop()
      while (this.schedulesAnimTimeout.length > 0) {
        clearTimeout(this.schedulesAnimTimeout.pop())
      }
    },
    alignDayPin(idx) {
      this.pinEl.style.marginLeft = window.innerWidth + 'px'
      this.pinEl.style.transform = `translate3d(${this.pxToRem(
        51 + 76.5 + idx * 174
      )}, 0, 0)`
    },
    onTimeClick(i, s) {
      this.selectedTime = i
      console.log(999, s)
      this.$emit('picked', s)
    },
    pxToRem(px) {
      return `${px * 0.01}rem`
    },
    syncIndicator() {
      this.lineEl.style.transform = this.swiperWrapperEl.style.transform
      this.lineEl.style.transitionDuration = this.swiperWrapperEl.style.transitionDuration
    },
  },
  created() {
    //this.GetCalenders()
  },
  mounted() {
    this.GetCalenders()
    this.lineEl = this.$refs.indicator
    this.swiperWrapperEl = this.$refs.swiperWrapper
    this.pinEl = this.$refs.pin
  },
  updated() {
    this.swiper.update()
    this.lineEl.style.width = `${this.swiper.$wrapperEl[0].scrollWidth +
      window.innerWidth * 2}px`
    this.lineEl.style.left = `${-window.innerWidth}px`
  },
  destroy() {
    Raf.remove(this.syncIndicator)
  },
}
</script>

<style scoped lang="sass">
@import "~swiper/swiper-bundle.min.css"
@import "../../styles/common"
.date-picker
  width: 100%
  height: 100%
  color: black
  //display: flex
  //justify-content: space-between
  //flex-direction: column
  .month
    font-family: "DINAlternate", sans-serif
    font-size: pxToRem(110)
    font-weight: bold
    flex-shrink: 0
    display: flex
    align-items: baseline
    flex-direction: row
    span
      font-size: pxToRem(40)
  .slides
    flex-shrink: 0
    width: 100%
    .swiper-container
      width: 100%
      overflow: visible
      .swiper-slide
        width: pxToRem(144+30)
        height: pxToRem(144)
        .day-card
          width: pxToRem(144)
          height: pxToRem(144)
          margin-right: pxToRem(30)
          border-radius: pxToRem(8)
          box-shadow: pxToRem(-10) pxToRem(-10) pxToRem(17) 0 rgba(255,255,255,0.02),  pxToRem(-19) pxToRem(-10) pxToRem(23) 0 rgba(252,252,252,0.74),  pxToRem(-12) pxToRem(8) pxToRem(17) 0 rgba(252,252,252,0.35),  pxToRem(2) pxToRem(13) pxToRem(43) 0 rgba(228,228,228,0.80)
          .copy
            color: #333333
            text-align: center
            padding-top: pxToRem(22)
            .week
              font-size: pxToRem(24)
            .day
              font-family: "DINAlternate", sans-serif
              margin-top: pxToRem(5)
              font-size: pxToRem(50)
              font-weight: bold
          &.selected
            background-image: linear-gradient(135deg, #168BFF 0%, #1664FF 100%)
            box-shadow: pxToRem(2) pxToRem(13) pxToRem(23) pxToRem(-10) rgba(22,139,255,0.60)
            .copy
              color: #FFFFFF
  .indicator
    flex-shrink: 0
    width: 100%
    margin-top: pxToRem(60)
    .wrapper
      position: relative
      height: pxToRem(49)
      width: 100%
      background-image: url("~assets/indicator-line.jpg")
      background-repeat: repeat-x
      background-size: auto 100%
      .pin
        position: absolute
        top: 0
        left: pxToRem(-81)
        transition: transform 0.5s ease
        height: 100%
        width: pxToRem(51)
  .picker
    margin-top: pxToRem(30)
    flex-shrink: 0
    width: 100%
    // height: pxToRem(690)
    overflow-x: hidden
    overflow-y: scroll
    .time-picker
      //transition: all 0.3s
      width: 100%

@keyframes fadeIn
  0%
    transform: translate3d(10%, 10%, 0)
    opacity: 0
  100%
    transform: translate3d(0, 0, 0)
    opacity: 1
.fade-enter-active
  transition: all 0.5s
.fade-leave-active
  transition: all 0.1s
.fade-enter, .fade-leave-to
  transform: translate3d(10%, 10%, 0)
  opacity: 0
</style>
